/* global window */

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import Cookie from "js-cookie";

// components
import CardTitlePart from "../../../parts/CardTitlePart";
import CardBannerPart from "../../../parts/CardBannerPart";
import TextCTA from "../../../layout/buttons/TextCTA";
import HtmlPart from "../../../parts/HtmlPart";
import XmasBanner from "./XmasBanner";

// config
import { config } from "../../../config/";

// actions
import {
  addRangeAsFavourite,
  removeRangeAsFavourite,
} from "../../../actions/activity";

// services
import { gtmCardEvent } from "../../../services/gtmService";
import { exponeaUpdateFavourites } from "../../../services/exponeaService";

const GTM_SWITCH = {
  favourites: "favourites",
  recentlyviewed: "recently-viewed",
};

class _RangeDisplayCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFavourite: this.isFavourite(),
    };
    this.handleToggleFavourites = this.handleToggleFavourites.bind(this);
  }

  componentWillReceiveProps(newProps) {
    const props = this.props;
    if (!this.props.favourites) return;
    if (props.favourites.length !== newProps.favourites.length) {
      this.setState({
        isFavourite: !!newProps.favourites.find(
          (i) => i.rangeName === props.range.rangeName
        ),
      });
    }
  }

  handleToggleFavourites() {
    const { range, addRangeAsFavourite, removeRangeAsFavourite } = this.props;
    const { isFavourite } = this.state;
    // flip local state to avoid delays
    this.setState({ isFavourite: !isFavourite });
    if (isFavourite) {
      gtmCardEvent(
        GTM_SWITCH[this.props.activityType],
        "un-favourite-range",
        range.rangeNameForUrl
      )();
      return removeRangeAsFavourite(range.rangeName).then((newFavs) =>
        exponeaUpdateFavourites("remove", range, newFavs)
      );
    }
    gtmCardEvent(
      GTM_SWITCH[this.props.activityType],
      "favourite-range",
      range.rangeNameForUrl
    )();
    return addRangeAsFavourite(range.rangeName, range.catNo).then((newFavs) =>
      exponeaUpdateFavourites("add", range, newFavs)
    );
  }

  render() {
    const {
      range,
      titleFormat,
      xmasCountDown,
      xmasCutOffDate,
      activityType,
    } = this.props;
    const { isFavourite } = this.state;
    const sofologistCookie = Cookie.getJSON("mySofologySofologist");
    const rangeLink =
      sofologistCookie == null
        ? `${
            config.URLS.SOFOLOGY_HOME
          }/sofas/${range.rangeNameForUrl.toLowerCase()}?category=My%20Favourites&code=${
            range.catNo
          }`
        : "";
    return (
      <div className="c-range-display">
        <CardTitlePart
          title={
            <HtmlPart
              htmlString={titleFormat || ""}
              swaps={{ range: range.rangeName }}
            />
          }
        />

        {xmasCountDown && (
          <XmasBanner
            range={range}
            xmasCutOffDate={moment(xmasCutOffDate, "MM/DD/YYYY")}
          />
        )}
        <CardBannerPart
          onImageClick={gtmCardEvent(
            GTM_SWITCH[activityType],
            "click-range",
            range.rangeNameForUrl
          )}
          imageSrc={range.cdnHeroImage}
          imgAltText={`the ${range.rangeName} range`}
          imageHref={rangeLink}
        />

        <div className="c-event-feed__card__splitter u-flex u-flex-justify-space-between">
          <i
            className={`sa sa-heart-o u-margin-left-small c-range-display__like-btn ${
              isFavourite ? "c-range-display__like-btn--active" : ""
            } u-clickable-link`}
            onClick={this.handleToggleFavourites}
          />
          <TextCTA
            text={"VIEW RANGE"}
            type="confirm"
            onBtnClick={gtmCardEvent(
              GTM_SWITCH[activityType],
              "click-range",
              range.rangeNameForUrl,
              () => window.location.replace(rangeLink)
            )}
          />
        </div>

        <div className="u-flex u-flex-column u-flex-align-items-center u-padding-x-tiny c-range-display__info">
          <section className="u-flex u-flex-justify-space-between u-padding-top-small u-w-100">
            {this.renderColors(range, rangeLink)}
            {this.renderLikes(range)}
          </section>

          <section className="u-flex u-flex-justify-space-between u-padding-y-small u-w-100">
            {this.renderConfigs(range, rangeLink)}
            {this.renderDelivery(range)}
          </section>

          <p className="u-text-center u-margin-reset u-padding-bottom-tiny c-range-display__prices u-w-100">
            <strong>£{range.lowestPriceInRange} </strong>{" "}
            <span
              style={{
                marginLeft: "3px",
                marginRight: "3px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
            >
              ı
            </span>
            <strong> 0% APR</strong> Flexible finance{" "}
            <a
              style={{ color: "#000", textDecoration: "underline" }}
              href="https://www.sofology.co.uk/sofology/payment-options"
            >
              options available
            </a>
          </p>
        </div>
      </div>
    );
  }

  renderColors(range, rangeLink) {
    return (
      <a
        href={rangeLink}
        className="c-range-display__colors"
        title={`View the ${range.rangeName} Range`}
      >
        <img
          alt="color swatches"
          src="https://images.sofology.co.uk/image/upload/v1484665799/custom-icons/colour-balls-icon.png"
          className="u-margin-right-tiny"
        />
        <span>{range.numberOfVariants} Colours</span>
      </a>
    );
  }

  renderLikes(range) {
    return (
      <div className="c-range-display__likes">
        <i className="sa sa-heart u-margin-right-micro" aria-hidden="true" />
        <strong>{range.numberOfLikes}</strong>
        <strong>&nbsp;Likes</strong>
      </div>
    );
  }

  renderConfigs(range, rangeLink) {
    return (
      <div className="c-range-display__sizes">
        <a title={`View the ${range.rangeName} Range`} href={rangeLink}>
          <img
            alt="sofa configurations"
            src="https://images.sofology.co.uk/image/upload/v1484665800/custom-icons/sizes-icon.png"
            className="u-margin-right-tiny"
          />
          <span>{range.numberOfProductItems} Sizes</span>
        </a>
      </div>
    );
  }

  renderDelivery(range) {
    return (
      <div className="c-range-display__delivery">
        <div>
          {range.earliestStockAvailability
            ? [
                <i
                  className="sa sa-delivery u-margin-right-tiny"
                  aria-hidden="true"
                />,
                range.earliestStockAvailability,
              ]
            : null}
        </div>
      </div>
    );
  }

  isFavourite() {
    const { range, favourites = [] } = this.props;
    return !!favourites.find((i) => i.rangeName === range.rangeName);
  }
}

const mapStateToProps = (state) => ({
  favourites: state.activity.favourites,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addRangeAsFavourite,
      removeRangeAsFavourite,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(_RangeDisplayCard);



// WEBPACK FOOTER //
// ./src/cards/templates/RangeDisplayCard/index.js